module.exports = __webpack_public_path__ + "img/toks.cc42874b.webp";